module.exports = __webpack_public_path__ + "img/infinity.9c27907b.png";